export const MODAL_ID_BENEFITS = 'ACCEPT_TERM_BENEFIT'
export const breadcrumbBeepList = [
  {
    route: `/`,
    title: 'Início',
    active: false,
  },
  {
    route: `/meus-beneficios`,
    title: 'Meus benefícios',
    active: false,
  },
  {
    route: `/meus-beneficios/beep-saude`,
    title: 'Beep Saúde',
    active: true,
  },
]

export const breadcrumbLaboratoriesList = [
  {
    route: `/`,
    title: 'Início',
    active: false,
  },
  {
    route: `/meus-beneficios`,
    title: 'Meus benefícios',
    active: false,
  },
  {
    route: `/meus-beneficios/laboratorios-parceiros`,
    title: 'Desconto em laboratórios',
    active: true,
  },
]
export const breadcrumbDiscountPharmacies = [
  {
    route: `/`,
    title: 'Início',
    active: false,
  },
  {
    route: `/meus-beneficios`,
    title: 'Meus benefícios',
    active: false,
  },
  {
    route: `/meus-beneficios/farmacias-desconto`,
    title: 'Desconto em farmácias',
    active: true,
  },
]
